export const sightWords = [
  "i",
  "can",
  "see",
  "the",
  "a",
  "at",
  "and",
  "like",
  "me",
  "we",
  "be",
  "he",
  "she",
  "to",
  "it",
  "is",
  "in",
  "my",
  "by",
  "on",
  "his",
  "had",
  "was",
  "for",
  "have",
  "go",
  "am",
  "as",
  "are",
  "look",
  "you",
  "up",
  "all",
  "because",
  "with",
  "they",
  "has"
];
